/* Shared UI helpers (avoids duplicated/nested-ternary color logic). */

export function scoreColor(score) {
  if (score >= 80) return "#D92D20";
  if (score >= 55) return "#FBBF24";
  return "#A3A3A3";
}

export function jobStatusColor(status) {
  if (status === "done") return "#22C55E";
  if (status === "error") return "#D92D20";
  return "#FBBF24";
}
